/**
 * Minimal logger interface for RUM internals (oversized-payload warnings,
 * etc.). Defaults to `console` so warn signals aren't silently dropped
 * before the host app wires its own log sink. Famfam wires
 * `setRumLogger(clientLogger)` once — see `famfam/lib/client/log-tunnel-provider.tsx`.
 *
 * Kept separate from the action / init modules so test-only resets and
 * production wiring don't entangle: a test that wants to silence warns
 * can `setRumLogger({ warn: () => {} })` without touching action state.
 */

export interface RumLogger {
  warn(message: string, meta?: unknown): void;
}

let logger: RumLogger = console;

/** Replaces the active RUM logger sink; famfam calls this once at startup to wire in its structured client logger in place of the default `console`. */
export function setRumLogger(next: RumLogger): void {
  logger = next;
}

/** Returns the currently active logger so RUM internals can emit warnings through the same sink the host app wired. */
export function getRumLogger(): RumLogger {
  return logger;
}

/** Restores the default `console` logger so spy-based tests don't leak a custom sink into subsequent tests. @visibleForTesting */
export function resetRumLogger(): void {
  logger = console;
}
